import { MarketingConsentPayload } from "@/models/marketingConsent";
import { apiEndpoints } from "core/api/apiEndpoints";
import { httpRequest } from "core/api/httpRequest";

// get consent content
const getConsentContent = () => {
  return httpRequest(apiEndpoints.getConsentContent, "get");
};

//get user specific consent
const getUserSpecificConsent = () => {
  return httpRequest(apiEndpoints.getUserSpecificConsent, "get");
};

//submit user specific consent
const saveUserSpecificConsent = (payload: any) => {
  // this was a put request later changed to post request
  return httpRequest(apiEndpoints.saveUserSpecificConsent, "post", payload);
};

// get marketing consent
const getMarketingConsent = () => {
  return httpRequest(apiEndpoints.marketingConsent, "get");
};

// save marketing consent
const saveMarketingConsent = (payload: MarketingConsentPayload) => {
  return httpRequest(apiEndpoints.marketingConsent, "post", payload);
};

export {
  getConsentContent,
  getUserSpecificConsent,
  saveUserSpecificConsent,
  getMarketingConsent,
  saveMarketingConsent,
};
